<ng-container *ngIf="dialogMode$ | async as dialogMode">
	<h1 mat-dialog-title *ngIf="dialogMode !== 'create-createPallet' && dialogMode !== 'create-w-createPallet'" style="font-weight: 800; margin: 0">{{ title$ | async }}</h1>
	<ng-container [ngSwitch]="loadingState$ | async">
		<ng-container *ngIf="_likutWarehouse.buttonsAndText$ | async as buttonsAndText">
			<mat-spinner *ngSwitchCase="'loading'" color="primary"></mat-spinner>
			<ng-container *ngSwitchCase="'idle'">
				<div mat-dialog-content [ngSwitch]="dialogMode" dir="rtl" style="padding: 0; width: 100%; max-height: 70vh">
					<form *ngIf="dialogMode === 'create-chooseProduct' || dialogMode === 'create-w-chooseProduct'" class="grid" style="font-size: large">
						<mat-form-field [formGroup]="chooseProductForm">
							<mat-label>{{ buttonsAndText['create-pallet-product-select-label'] | buttonText }}</mat-label>
							<input
								type="text"
								[placeholder]="buttonsAndText['create-pallet-product-select-placeholder'] | buttonText"
								aria-label="product"
								matInput
								formControlName="product"
								[matAutocomplete]="auto"
							/>
							<mat-autocomplete #auto="matAutocomplete">
								<mat-option panelClass="flex flex-column" *ngFor="let product of filteredProducts$ | async" [value]="product.ProductId">
									<span> {{ product.ProductName }} </span> <span>{{ product.ForigenName }}</span>
								</mat-option>
							</mat-autocomplete>
							<mat-error>{{ buttonsAndText['required-field'] | buttonText }}</mat-error>
						</mat-form-field>
					</form>
					<form [formGroup]="chooseWarehouseForm" *ngSwitchCase="'transfer-chooseWarehouse'" class="grid" style="font-size: large">
						<mat-form-field>
							<mat-label>{{ buttonsAndText['pallet-transfer-warehouse-select-label'] | buttonText }}</mat-label>
							<mat-select formControlName="warehouse" [placeholder]="buttonsAndText['pallet-transfer-warehouse-select-placeholder'] | buttonText">
								<mat-option *ngFor="let warehouse of _likutWarehouse.warehouses$ | async" [value]="warehouse.WarehouseID">
									{{ warehouse.WarehouseName }}
								</mat-option>
							</mat-select>
							<mat-error>{{ buttonsAndText['required-field'] | buttonText }}</mat-error>
						</mat-form-field>
					</form>
					<form [formGroup]="chooseWarehouseForm" *ngSwitchCase="'transferFromAllInventoryReport'" class="grid" style="font-size: large">
						<mat-form-field>
							<mat-label>{{ buttonsAndText['pallet-transfer-warehouse-select-label'] | buttonText }}</mat-label>
							<mat-select formControlName="warehouse" [placeholder]="buttonsAndText['pallet-transfer-warehouse-select-placeholder'] | buttonText">
								<mat-option *ngFor="let warehouse of _likutWarehouse.warehousesAll$ | async" [value]="warehouse.WarehouseID">
									{{ warehouse.WarehouseName }}
								</mat-option>
							</mat-select>
							<mat-error>{{ buttonsAndText['required-field'] | buttonText }}</mat-error>
						</mat-form-field>
						<ng-container *ngIf="scannedPalletsDisplay$ | async as pallets">
							<h3 *ngIf="pallets.length">
								סה"כ <b>{{ pallets.length }}</b> נסרקו
							</h3>
							<div class="pallet-wrapper">
								<div class="pallet-row in" *ngFor="let pallet of pallets">
									<div class="flex" style="max-height: 80px; flex: 1">
										<img appFallbackSrc crossorigin="anonymous" style="width: 100%; object-fit: contain" alt="product" [src]="imageUrl + '/' + pallet.ProductId + '.jpg'" />
									</div>
									<div class="flex flex-column justify-center align-center" style="flex: 1">
										<span>
											<b>{{ buttonsAndText['pallet-transfer-pallet-list-productID-label'] | buttonText }}:</b> {{ pallet.ProductId }}
										</span>
										<span>
											<b>{{ buttonsAndText['pallet-transfer-pallet-list-palletID-label'] | buttonText }}:</b> {{ pallet.PaletteID }}
										</span>
										<span>
											<b>{{ buttonsAndText['pallet-transfer-pallet-list-tokef-label'] | buttonText }}:</b> {{ pallet.TokefDate | date : 'dd/MM/yy' : 'GMT' }}
										</span>
									</div>
								</div>
							</div>
						</ng-container>
					</form>
					<form [formGroup]="chooseWarehouseForm" *ngSwitchCase="'inventory-scan'" class="grid" style="font-size: large">
						<mat-form-field>
							<mat-label>{{ buttonsAndText['inventory-scan-warehouse-select-label'] | buttonText }}</mat-label>
							<mat-select formControlName="warehouse" [placeholder]="buttonsAndText['inventory-scan-warehouse-select-placeholder'] | buttonText">
								<mat-option *ngFor="let warehouse of _likutWarehouse.warehouses$ | async" [value]="warehouse.WarehouseID">
									{{ warehouse.WarehouseName }}
								</mat-option>
							</mat-select>
							<mat-error>{{ buttonsAndText['required-field'] | buttonText }}</mat-error>
						</mat-form-field>
					</form>
					<form [formGroup]="chooseWarehouseForm" *ngSwitchCase="'delete-chooseWarehouse'" class="grid" style="font-size: large">
						<mat-form-field>
							<mat-label>{{ buttonsAndText['pallet-send-out-warehouse-select-label'] | buttonText }}</mat-label>

							<mat-select formControlName="warehouse" [placeholder]="buttonsAndText['pallet-send-out-warehouse-select-placeholder'] | buttonText">
								<mat-option *ngFor="let warehouse of _likutWarehouse.warehouses$ | async" [value]="warehouse.WarehouseID">
									{{ warehouse.WarehouseName }}
								</mat-option>
							</mat-select>
							<mat-error>{{ buttonsAndText['required-field'] | buttonText }}</mat-error>
						</mat-form-field>
					</form>

					<ng-container *ngIf="dialogMode === 'create-createPallet' || dialogMode === 'create-w-createPallet'">
						<!-- <ng-container *ngSwitchCase="'create-createPallet'"> -->
						<ng-container *ngIf="chosenProduct$ | async as product">
							<div>
								<div class="flex justify-evenly align-center">
									<img style="max-height: 128px; max-width: 166px" [src]="imageUrl + '/' + product.ItemPicName + '.jpg'" appFallbackSrc crossorigin="anonymous" alt="product" />
									<div class="flex flex-column">
										<h2 class="text-align-center" style="font-weight: 800; margin: 0">{{ title$ | async }}</h2>
										<h2 class="text-align-center" style="font-weight: 800; margin: 0">{{ product.ProductName }}</h2>
										<h2 class="text-align-center" style="font-weight: 800; margin: 0">{{ product.ForigenName }}</h2>
									</div>
								</div>
								<h3 style="font-weight: 800; margin: 0">{{ buttonsAndText['create-pallet-barcode-label'] | buttonText }}: {{ product.Barcode }}</h3>
								<h3 style="font-weight: 800" class="flex justify-between">
									<span>{{ buttonsAndText['create-pallet-productID-label'] | buttonText }}: {{ product.ProductId }}</span>
									<span>{{ buttonsAndText['create-pallet-itempack-label'] | buttonText }}: {{ product.ItemPack }}</span>
								</h3>
							</div>
							<form [formGroup]="createPalletForm" class="grid" style="font-size: large">
								<mat-form-field>
									<mat-label>{{ buttonsAndText['create-pallet-tokef-datepicker-label'] | buttonText }}</mat-label>
									<mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
									<input matInput [min]="dateRange.min" [max]="dateRange.max" formControlName="date" (click)="picker.open()" [matDatepicker]="picker" readonly />
									<mat-datepicker #picker></mat-datepicker>
									<mat-error>{{ buttonsAndText['required-field'] | buttonText }}</mat-error>
								</mat-form-field>
								<mat-form-field>
									<mat-label>{{ buttonsAndText['create-pallet-packperpallet-label'] | buttonText }}</mat-label>
									<input matInput formControlName="packsPerPallet" [placeholder]="product.PackPerPallet + ''" inputmode="numeric" />
									<mat-error>{{ buttonsAndText['required-field'] | buttonText }}</mat-error>
								</mat-form-field>
								<mat-form-field *ngIf="shouldAddMainRemark$ | async">
									<mat-label>{{ buttonsAndText['create-pallet-extra4-label'] | buttonText }}</mat-label>
									<input matInput formControlName="extra4" [placeholder]="buttonsAndText['create-pallet-extra4-placeholder'] | buttonText" />
									<mat-error>{{ buttonsAndText['required-field'] | buttonText }}</mat-error>
								</mat-form-field>
								<mat-form-field>
									<mat-label>{{ buttonsAndText['create-pallet-warehouse-select-label'] | buttonText }}</mat-label>
									<mat-select formControlName="warehouse" [placeholder]="buttonsAndText['create-pallet-warehouse-select-placeholder'] | buttonText">
										<mat-option *ngFor="let warehouse of _likutWarehouse.warehouses$ | async" [value]="warehouse.WarehouseID">
											{{ warehouse.WarehouseName }}
										</mat-option>
									</mat-select>
									<mat-error>{{ buttonsAndText['required-field'] | buttonText }}</mat-error>
								</mat-form-field>
								<mat-form-field>
									<mat-label>{{ buttonsAndText['create-pallet-printer-select-label'] | buttonText }}</mat-label>
									<mat-select formControlName="printer" [placeholder]="buttonsAndText['create-pallet-printer-select-placeholder'] | buttonText">
										<mat-option *ngFor="let printer of _likutWarehouse.printers$ | async" [value]="printer.PrinterID">
											{{ printer.PrinterName }}
										</mat-option>
									</mat-select>
									<mat-error>{{ buttonsAndText['required-field'] | buttonText }}</mat-error>
								</mat-form-field>
								<mat-form-field>
									<mat-label>{{ buttonsAndText['create-pallet-palletnum-label'] | buttonText }}</mat-label>
									<input matInput formControlName="palletNum" inputmode="numeric" />
									<mat-error>{{ buttonsAndText['required-field'] | buttonText }}</mat-error>
								</mat-form-field>
							</form>
						</ng-container>
					</ng-container>
					<form *ngSwitchCase="'reprint'" [formGroup]="reprintForm" class="grid" style="font-size: large">
						<mat-form-field>
							<mat-label>{{ buttonsAndText['pallet-reprint-pallet-select-label'] | buttonText }}</mat-label>
							<input matInput formControlName="pallet" [placeholder]="buttonsAndText['pallet-reprint-pallet-select-placeholder'] | buttonText" />
							<mat-error>{{ buttonsAndText['required-field'] | buttonText }}</mat-error>
						</mat-form-field>
						<mat-form-field>
							<mat-label>{{ buttonsAndText['pallet-reprint-printer-select-label'] | buttonText }}</mat-label>
							<mat-select formControlName="printer" [placeholder]="buttonsAndText['pallet-reprint-printer-select-placeholder'] | buttonText">
								<mat-option *ngFor="let printer of _likutWarehouse.printers$ | async" [value]="printer.PrinterID">{{ printer.PrinterName }}</mat-option>
							</mat-select>
							<mat-error>{{ buttonsAndText['required-field'] | buttonText }}</mat-error>
						</mat-form-field>
					</form>
					<form
						*ngSwitchCase="'transfer-transferPallet'"
						[formGroup]="transferOrSendoutPalletForm"
						class="grid"
						style="font-size: large"
						(ngSubmit)="palletTransferFormSubmit$.next(transferOrSendoutPalletForm.controls.pallet.value)"
					>
						<mat-form-field>
							<mat-label>{{ buttonsAndText['pallet-transfer-palletID-label'] | buttonText }}</mat-label>
							<input matInput formControlName="pallet" [placeholder]="buttonsAndText['pallet-transfer-palletID-placeholder'] | buttonText" />
							<mat-error>{{ buttonsAndText['required-field'] | buttonText }}</mat-error>
						</mat-form-field>

						<ng-container *ngIf="scannedPalletsDisplay$ | async as pallets">
							<h4>מחסן: {{ chooseWarehouseForm.controls.warehouse.value }}</h4>
							<h4 *ngIf="pallets.length">
								סה"כ <b>{{ pallets.length }}</b> נסרקו
							</h4>
							<div class="pallet-wrapper" *ngIf="_likutWarehouse.productsDictionary$ | async as productsDictionary">
								<div class="pallet-row in" *ngFor="let pallet of pallets">
									<div class="grid place-items-center" style="max-height: 80px">
										<button mat-icon-button color="warn" type="button" (click)="removeScannedPallet({ e: $event, pallet })">
											<mat-icon>cancel</mat-icon>
										</button>
									</div>
									<div class="flex" style="max-height: 80px; flex: 1">
										<img appFallbackSrc crossorigin="anonymous" style="width: 100%; object-fit: contain" alt="product" [src]="imageUrl + '/' + pallet.ProductId + '.jpg'" />
									</div>
									<div class="flex flex-column justify-center align-center" style="flex: 1">
										<!-- <span>
											<b>{{ buttonsAndText['pallet-transfer-pallet-list-productID-label'] | buttonText }}:</b> {{ pallet.ProductId }}
										</span> -->
										<span style="unicode-bidi: bidi-override">
											<b [ngSwitch]="forcedLocale">
												<ng-container *ngSwitchCase="null">{{ productsDictionary[pallet.ProductId]?.ProductName }}</ng-container>
												<ng-container *ngSwitchCase="'0'">{{ productsDictionary[pallet.ProductId]?.ProductName }}</ng-container>
												<ng-container *ngSwitchCase="'1'">{{ productsDictionary[pallet.ProductId]?.ProductName }} - {{ productsDictionary[pallet.ProductId]?.ForigenName }}</ng-container>
												<ng-container *ngSwitchCase="'2'">{{ productsDictionary[pallet.ProductId]?.ForigenName }}</ng-container>
											</b>
											{{ pallet.ProductId }}
										</span>
										<span>
											<b>{{ buttonsAndText['pallet-transfer-pallet-list-palletID-label'] | buttonText }}:</b> {{ pallet.PaletteID }}
										</span>
										<span>
											<b>{{ buttonsAndText['pallet-transfer-pallet-list-tokef-label'] | buttonText }}:</b> {{ pallet.TokefDate | date : 'dd/MM/yy' : 'GMT' }}
										</span>
									</div>
								</div>
							</div>
						</ng-container>
					</form>
					<form
						*ngSwitchCase="'delete-sendPalletOut'"
						[formGroup]="transferOrSendoutPalletForm"
						class="grid"
						style="font-size: large"
						(ngSubmit)="palletTransferFormSubmit$.next(transferOrSendoutPalletForm.controls.pallet.value)"
					>
						<mat-form-field>
							<mat-label>{{ buttonsAndText['pallet-send-out-palletID-label'] | buttonText }}</mat-label>
							<input matInput formControlName="pallet" [placeholder]="buttonsAndText['pallet-send-out-palletID-placeholder'] | buttonText" />
							<mat-error> {{ buttonsAndText['required-field'] | buttonText }} </mat-error>
						</mat-form-field>
						<ng-container *ngIf="scannedPalletsDisplay$ | async as pallets">
							<h3 *ngIf="pallets.length">
								סה"כ <b>{{ pallets.length }}</b> נסרקו
							</h3>
							<div class="pallet-wrapper" *ngIf="_likutWarehouse.productsDictionary$ | async as productsDictionary">
								<div class="pallet-row in" *ngFor="let pallet of pallets">
									<div class="grid place-items-center" style="max-height: 80px">
										<button mat-icon-button color="warn" type="button" (click)="removeScannedPallet({ e: $event, pallet })">
											<mat-icon>cancel</mat-icon>
										</button>
									</div>
									<div class="flex" style="max-height: 80px; flex: 1">
										<img appFallbackSrc crossorigin="anonymous" style="width: 100%; object-fit: contain" alt="product" [src]="imageUrl + '/' + pallet.ProductId + '.jpg'" />
									</div>
									<div class="flex flex-column justify-center align-center" style="flex: 1">
										<!-- <span>
											<b>{{ buttonsAndText['pallet-send-out-pallet-list-productID-label'] | buttonText }}:</b>
											{{ pallet.ProductId }}
										</span> -->
										<span style="unicode-bidi: bidi-override">
											<b [ngSwitch]="forcedLocale">
												<ng-container *ngSwitchCase="null">{{ productsDictionary[pallet.ProductId]?.ProductName }}</ng-container>
												<ng-container *ngSwitchCase="'0'">{{ productsDictionary[pallet.ProductId]?.ProductName }}</ng-container>
												<ng-container *ngSwitchCase="'1'">{{ productsDictionary[pallet.ProductId]?.ProductName }} - {{ productsDictionary[pallet.ProductId]?.ForigenName }}</ng-container>
												<ng-container *ngSwitchCase="'2'">{{ productsDictionary[pallet.ProductId]?.ForigenName }}</ng-container>
											</b>
											{{ pallet.ProductId }}
										</span>
										<span>
											<b>{{ buttonsAndText['pallet-send-out-pallet-list-palletID-label'] | buttonText }}:</b>
											{{ pallet.PaletteID }}
										</span>
										<span>
											<b>{{ buttonsAndText['pallet-send-out-pallet-list-tokef-label'] | buttonText }}:</b>
											{{ pallet.TokefDate | date : 'dd/MM/yy' : 'GMT' }}
										</span>
									</div>
								</div>
							</div>
						</ng-container>
					</form>
					<form
						*ngSwitchCase="'pallet-info-choosePallet'"
						[formGroup]="transferOrSendoutPalletForm"
						(ngSubmit)="palletInfoFormSubmit$.next(transferOrSendoutPalletForm.controls.pallet.value)"
						class="grid"
						style="font-size: large"
					>
						<mat-form-field>
							<mat-label>{{ buttonsAndText['pallet-send-out-palletID-label'] | buttonText }}</mat-label>
							<input matInput [readonly]="_loading.isLoading$ | async" formControlName="pallet" [placeholder]="buttonsAndText['pallet-send-out-palletID-placeholder'] | buttonText" />
							<mat-error> {{ buttonsAndText['required-field'] | buttonText }} </mat-error>
						</mat-form-field>
					</form>
					<ng-container *ngSwitchCase="'pallet-info-palletInfo'">
						<ng-container *ngIf="chosenProduct$ | async as product">
							<div>
								<div class="flex justify-evenly align-center">
									<img style="max-height: 128px; max-width: 166px" [src]="imageUrl + '/' + product.ItemPicName + '.jpg'" appFallbackSrc crossorigin="anonymous" alt="product" />
									<div class="flex flex-column">
										<h2 class="text-align-center" style="font-weight: 800; margin: 0">{{ product.ProductName }}</h2>
										<h2 class="text-align-center" style="font-weight: 800; margin: 0">{{ product.ForigenName }}</h2>
									</div>
								</div>
								<h3 style="font-weight: 800; margin: 0">{{ buttonsAndText['create-pallet-barcode-label'] | buttonText }}: {{ product.Barcode }}</h3>
								<h3 style="font-weight: 800" class="flex justify-between">
									<span>{{ buttonsAndText['create-pallet-productID-label'] | buttonText }}: {{ product.ProductId }}</span>
									<span>{{ buttonsAndText['create-pallet-itempack-label'] | buttonText }}: {{ product.ItemPack }}</span>
								</h3>
							</div>
							<form [formGroup]="palletInfoForm" class="grid" style="font-size: large">
								<mat-form-field>
									<mat-label>{{ buttonsAndText['create-pallet-tokef-datepicker-label'] | buttonText }}</mat-label>
									<mat-datepicker-toggle matSuffix [for]="pickerTokef"></mat-datepicker-toggle>
									<input matInput [min]="dateRange.min" [max]="dateRange.max" formControlName="tokefDate" [matDatepicker]="pickerTokef" readonly />
									<mat-datepicker #pickerTokef></mat-datepicker>
									<mat-error>{{ buttonsAndText['required-field'] | buttonText }}</mat-error>
								</mat-form-field>
								<mat-form-field>
									<mat-label>{{ buttonsAndText['pallet-info-create-datepicker-label'] | buttonText }}</mat-label>
									<mat-datepicker-toggle matSuffix [for]="pickerCreate"></mat-datepicker-toggle>
									<input matInput [min]="dateRange.min" [max]="dateRange.max" formControlName="createDate" [matDatepicker]="pickerCreate" readonly />
									<mat-datepicker #pickerCreate></mat-datepicker>
									<mat-error>{{ buttonsAndText['required-field'] | buttonText }}</mat-error>
								</mat-form-field>
								<mat-form-field>
									<mat-label>{{ buttonsAndText['create-pallet-packperpallet-label'] | buttonText }}</mat-label>
									<input matInput formControlName="packsPerPallet" [placeholder]="product.PackPerPallet + ''" inputmode="numeric" />
									<mat-error>{{ buttonsAndText['required-field'] | buttonText }}</mat-error>
								</mat-form-field>
								<mat-form-field>
									<mat-label>{{ buttonsAndText['create-pallet-extra4-label'] | buttonText }}</mat-label>
									<input matInput formControlName="extra4" [placeholder]="buttonsAndText['create-pallet-extra4-placeholder'] | buttonText" />
									<mat-error>{{ buttonsAndText['required-field'] | buttonText }}</mat-error>
								</mat-form-field>
								<mat-form-field>
									<mat-label>{{ buttonsAndText['create-pallet-warehouse-select-label'] | buttonText }}</mat-label>
									<input matInput formControlName="warehouse" />
									<!-- <mat-label>{{ buttonsAndText['create-pallet-warehouse-select-label'] | buttonText }}</mat-label> -->
									<!-- <mat-select formControlName="warehouse" [placeholder]="buttonsAndText['create-pallet-warehouse-select-placeholder'] | buttonText">
										<mat-option *ngFor="let warehouse of _likutWarehouse.warehouses$ | async" [value]="warehouse.WarehouseID">
											{{ warehouse.WarehouseName }}
										</mat-option>
									</mat-select> -->
									<mat-error>{{ buttonsAndText['required-field'] | buttonText }}</mat-error>
								</mat-form-field>
								<mat-form-field>
									<mat-label>{{ buttonsAndText['pallet-info-user-label'] | buttonText }}</mat-label>
									<input matInput formControlName="user" />
									<mat-error>{{ buttonsAndText['required-field'] | buttonText }}</mat-error>
								</mat-form-field>
							</form>
						</ng-container>
					</ng-container>
				</div>
				<div class="row flex justify-between" mat-dialog-actions>
					<button mat-raised-button cdkFocusInitial (click)="onPressClose()">
						{{ buttonsAndText['close-button'] | buttonText }}
					</button>
					<button mat-raised-button *ngIf="shouldButtonShow$ | async" style="background: var(--valid-color)" (click)="handleDialogSubmit()" [disabled]="isSubmitButtonDisabled$ | async">
						{{ buttonText$ | async }}
					</button>
				</div>
			</ng-container>
			<ng-container *ngSwitchCase="'success'">
				<h2 class="text-align-center valid-color">{{ successMessage$ | async }}</h2>
				<ng-container *ngIf="createdPalletIDs$ | async as palletIDs">
					<h2 *ngIf="palletIDs.length">
						<span>{{ buttonsAndText['create-pallet-success-palletIDs'] | buttonText }} : </span>
						<span *ngFor="let palletID of palletIDs; let last = last">{{ palletID }}{{ !last ? ', ' : '.' }}</span>
					</h2>
				</ng-container>

				<div class="order-process__image image">
					<img src="/assets/images/basket/process/save.gif" alt="photo" />
				</div>
			</ng-container>
			<ng-container *ngSwitchCase="'error'">
				<div class="row">
					<h2>{{ buttonsAndText['general-error-sending-request'].main }}</h2>
					<h2 *ngIf="buttonsAndText['general-error-sending-request'].sub">{{ buttonsAndText['general-error-sending-request'].sub }}</h2>
				</div>
				<div class="row" mat-dialog-actions>
					<button mat-raised-button color="primary" mat-dialog-close>
						{{ buttonsAndText['close-button'] | buttonText }}
					</button>
				</div>
			</ng-container>
		</ng-container>
	</ng-container>
</ng-container>
